(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/product-page-onboarding/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/templates/product-page-onboarding/assets/javascripts/init.js');
'use strict';

if (svs.page && svs.page.data && svs.page.data.templateConfig) {
  const branding = svs.page.data.templateConfig.branding;
  new svs.ui.ItemsMenu({
    el: "js-items-menu-".concat(branding),
    class: "js-items-menu-".concat(branding),
    useScrollHelpers: svs.core.detect.formfactor.desktop(),
    useScrollFaders: true,
    showScrollbar: false,
    scrollToSelected: true
  });
  const headerLogo = document.querySelector('.js-top-center-content');
  headerLogo === null || headerLogo === void 0 || headerLogo.addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      category: 'Navigation',
      action: 'logo click',
      opt_label: branding.toUpperCase()
    });
  });
}
const {
  value
} = svs.utils.paramHandler.get({
  key: 'grassrootstoasterredirect'
});
if (value) {
  svs.utils.paramHandler.remove({
    key: 'grassrootstoasterredirect'
  });
  requestAnimationFrame(() => {
    new svs.tur.GrassrootsToaster().show();
  });
}

 })(window);